import { render, staticRenderFns } from "./AffiliateCard.html?vue&type=template&id=cffd2bc8&scoped=true&"
import script from "./AffiliateCard.js?vue&type=script&lang=js&"
export * from "./AffiliateCard.js?vue&type=script&lang=js&"
import style0 from "./affiliate-card.scss?vue&type=style&index=0&id=cffd2bc8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffd2bc8",
  null
  
)

export default component.exports